<template>
  <button type="button" class="kingdom-card" :class="{ 'is-compact': compact }" @click="$emit('open')">
    <div class="kingdom-card__title">{{ title }}</div>
    <div ref="el" class="kingdom-card__chart" />
  </button>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'KingdomThumb',
  props: {
    compact: { type: Boolean, default: false },
    title: { type: String, default: '' },
    dates: { type: Array, default: () => [] },
    series: { type: Array, default: () => [] }
  },
  data() {
    return { chart: null }
  },
  watch: {
    series: { deep: true, handler() { this.draw() } },
    dates() { this.draw() }
  },
  mounted() {
    this.draw()
  },
  beforeDestroy() {
    if (this.chart) this.chart.dispose()
    this.chart = null
  },
  methods: {
    draw() {
      const el = this.$refs.el
      if (!el) return
      if (!this.chart) this.chart = echarts.init(el)
      const dates = this.dates || []
      const series = (this.series || []).map((item) => ({
        name: item.name,
        type: 'line',
        data: item.values || [],
        connectNulls: false,
        showSymbol: false,
        lineStyle: { color: item.color, width: 2 },
        itemStyle: { color: item.color }
      }))
      this.chart.setOption({
        animation: false,
        grid: { left: 42, right: 10, top: 16, bottom: 24 },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: dates,
          axisLabel: {
            fontSize: 10,
            color: '#606266',
            formatter: (value) => String(value).slice(5)
          },
          axisLine: { lineStyle: { color: '#d5e3f2' } }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            fontSize: 10,
            color: '#606266',
            formatter: (value) => `${value}%`
          },
          splitLine: { show: false }
        },
        series
      }, true)
      this.chart.resize()
    }
  }
}
</script>

<style lang="scss" scoped>
.kingdom-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 240px;
  padding: 8px 8px 4px;
  border: 1px solid #d7e6f5;
  border-radius: 8px;
  background: #fff;
  text-align: left;
  cursor: pointer;
}
.kingdom-card:hover { border-color: #409eff; }
.kingdom-card.is-compact {
  width: 320px;
  height: 168px;
  min-height: 0;
  .kingdom-card__chart { min-height: 0; }
}
.kingdom-card__title {
  font-size: 14px;
  font-weight: 700;
  color: #1f4e79;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.kingdom-card__chart { flex: 1; min-height: 190px; }
</style>
